import { CreateReferralV5Command } from "../../../types/CreateReferralCommandV5";
import UnitOfMeasure from "../../../enums/UnitOfMeasure";
import unitConverter from "../../../utils/UnitConverter";
import { programmes } from "../../../enums/programmes";

export const mapSignupFormValues = (programmeSlug, signupFormValues): CreateReferralV5Command => {
  const mappedSignupFormValues: CreateReferralV5Command = {
    PersonalDetails: {
      FirstName: signupFormValues?.firstName,
      LastName: signupFormValues?.lastName,
      Email: signupFormValues?.email,
      Postcode: signupFormValues?.postcode,
      PhoneNumber: signupFormValues?.phoneNumber,
      DateOfBirth: signupFormValues?.age,
      BirthSex: signupFormValues?.sex,
      CustomGender: signupFormValues?.gender,
      Ethnicity: signupFormValues?.ethnicity?.value || null,
    },
    GpDetails: {
      GpSurgery: signupFormValues?.gpSurgery,
      GpAddress: signupFormValues?.gpAddress,
    },
    PhysicalHealthConditions: signupFormValues?.physicalConditions,
    MentalHealthConditions: signupFormValues?.mentalConditions,
    WeightInKilos: getWeightInKilos(signupFormValues),
    HeightInCm: getHeightInCm(signupFormValues),
    Disabilities: signupFormValues?.disabilities,
    ServiceCode: signupFormValues?.serviceCode,
    ProgrammeIds: [programmes[programmeSlug].id],
    Pathway: signupFormValues?.pathway || null,
    EmailVerified: signupFormValues.emailVerified,
    employmentStatus: signupFormValues?.employmentStatus || null,
    isCarer: signupFormValues?.isCarer || null,
  };
  return mappedSignupFormValues;
};

const getWeightInKilos = signupFormValues => {
  let weightInKilos = null;
  if (signupFormValues?.weightDisplayUnitOfMeasure && signupFormValues?.weight) {
    weightInKilos =
      signupFormValues?.weightDisplayUnitOfMeasure === UnitOfMeasure.METRIC
        ? Number(signupFormValues?.weight)
        : unitConverter.poundsToKilograms(
            unitConverter.stonesToPounds(signupFormValues?.weightStones) +
              Number(signupFormValues?.weightPounds)
          );
  }
  return weightInKilos;
};

const getHeightInCm = signupFormValues => {
  let heightInCm = null;

  if (signupFormValues?.heightDisplayUnitOfMeasure && signupFormValues?.height) {
    heightInCm =
      signupFormValues?.heightDisplayUnitOfMeasure === UnitOfMeasure.METRIC
        ? Number(signupFormValues?.height)
        : unitConverter.feetAndInchesToCentimeters(
            signupFormValues?.heightFeet,
            signupFormValues?.heightInches
          );
  }
  return heightInCm;
};

export const mapSignupPagesData = pagesData => {
  const mappedData = {};
  let mappedIneligibleScreenData = {};
  pagesData.forEach(item => {
    item.ineligibleScreens.forEach(page => {
      mappedIneligibleScreenData[page.eligibilityCondition] = page;
    });
    item.ineligibleScreens = mappedIneligibleScreenData;
    mappedIneligibleScreenData = {};
    mappedData[item.slug] = item;
  });

  return mappedData;
};

export const mapPathwayCheckValues = signupFormValues => {
  const mappedPathwayValues = {
    serviceId: signupFormValues?.serviceId,
    programmeId: programmes["lose-weight"].id,
    physicalHealthConditions: signupFormValues?.physicalConditions,
    mentalHealthConditions: signupFormValues?.mentalConditions,
    weightInKilos:
      signupFormValues?.weightDisplayUnitOfMeasure === UnitOfMeasure.METRIC
        ? Number(signupFormValues?.weight)
        : unitConverter.poundsToKilograms(
            unitConverter.stonesToPounds(signupFormValues?.weightStones) +
              Number(signupFormValues?.weightPounds)
          ),
    heightInCm:
      signupFormValues?.heightDisplayUnitOfMeasure === UnitOfMeasure.METRIC
        ? Number(signupFormValues?.height)
        : unitConverter.feetAndInchesToCentimeters(
            signupFormValues?.heightFeet,
            signupFormValues?.heightInches
          ),
  };
  return mappedPathwayValues;
};

export const backButtonAction = (user: any) => {
  if (user) {
    window.location.href = "/";
  } else {
    window.location.href = "/select-programme";
  }
};

export const getLatestProfileJourneyLocal = profile => {
  return profile?.allJourneys
    .slice() // Create a shallow copy to avoid mutating the original array
    .sort((a, b) => new Date(b.startDate).getTime() - new Date(a.startDate).getTime())[0];
};
